import React from "react";
import { Drawer, Tag, Descriptions } from "antd";

const statusColor = (status) => {
  if (status === "completed") return "green";
  if (status === "failed") return "red";
  if (status === "in_progress") return "blue";
  return "default";
};

const formatDatetime = (dateStr) => {
  if (!dateStr) return "-";
  return new Date(dateStr).toLocaleString("en-US", {
    month: "short", day: "numeric", year: "numeric",
    hour: "2-digit", minute: "2-digit", second: "2-digit",
  });
};

const computeDuration = (startedAt, completedAt) => {
  if (!startedAt || !completedAt) return "-";
  const ms = new Date(completedAt) - new Date(startedAt);
  if (ms < 1000) return `${ms}ms`;
  const seconds = Math.floor(ms / 1000);
  if (seconds < 60) return `${seconds}s`;
  const minutes = Math.floor(seconds / 60);
  const remaining = seconds % 60;
  return `${minutes}m ${remaining}s`;
};

export default function JobDetailDrawer({ job, open, onClose }) {
  if (!job) return null;

  return (
    <Drawer
      title="Sync Job Details"
      open={open}
      onClose={onClose}
      width={500}
    >
      <Descriptions column={1} bordered size="small">
        <Descriptions.Item label="Job ID">{job.id}</Descriptions.Item>
        <Descriptions.Item label="Status">
          <Tag color={statusColor(job.status)}>{job.status}</Tag>
        </Descriptions.Item>
        <Descriptions.Item label="Trigger Source">{job.trigger_source || "-"}</Descriptions.Item>
        <Descriptions.Item label="Started At">{formatDatetime(job.started_at)}</Descriptions.Item>
        <Descriptions.Item label="Completed At">{formatDatetime(job.completed_at)}</Descriptions.Item>
        <Descriptions.Item label="Duration">
          {computeDuration(job.started_at, job.completed_at)}
        </Descriptions.Item>
        <Descriptions.Item label="Items Inserted">{job.items_inserted ?? 0}</Descriptions.Item>
        <Descriptions.Item label="Items Updated">{job.items_updated ?? 0}</Descriptions.Item>
        <Descriptions.Item label="Items Errored">{job.items_errored ?? 0}</Descriptions.Item>
        {job.error_summary && (
          <Descriptions.Item label="Error Summary">
            <pre style={{
              margin: 0,
              fontSize: 12,
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              maxHeight: 200,
              overflow: "auto",
              background: "#fafafa",
              padding: 8,
              borderRadius: 4,
            }}>
              {job.error_summary}
            </pre>
          </Descriptions.Item>
        )}
      </Descriptions>
    </Drawer>
  );
}
